import { createAction, props } from '@ngrx/store';
export const setComplianceReportHistoryStore = createAction('[Compliance Report History Page] Set Report History Store', props());
